import { styled } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import SearchInput from 'components/input-fields/SearchInput';
import { useLocation, useNavigate } from 'react-router-dom';
const SecondaryWrapper = styled(FlexBetween)(({ theme }) => ({
    gap: 8,
    flexWrap: 'wrap',
    margin: '24px 0',
    [theme.breakpoints.down(550)]: {
        '& .MuiInputBase-root': {
            maxWidth: 'calc(100% - 90px)',
        },
    },
})); // --------------------------------------------------------------------

// --------------------------------------------------------------------
const SearchArea = ({
    value,
    onChange,
    setValue,
    selectedItems,
    gridRoute,
    listRoute,
}) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const activeColor = (path) =>
        pathname === path ? 'primary.main' : 'text.disabled';

    return (
        <SecondaryWrapper>
            <SearchInput
                placeholder="Search..."
                value={value || ''}
                onChange={(e) => {
                    if (onChange && setValue) {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }

                    onChange(e.target.value);
                }}
            />
        </SecondaryWrapper>
    );
};

export default SearchArea;
